/* eslint-disable import/no-unresolved */
import { useDispatch, useSelector } from 'react-redux';
import {
  Modal,
  Box,
  Typography,
  Slide,
  Backdrop,
  IconButton,
} from '@mui/material';
import SubmitPaymentForm from '@/components/Forms/SubmitPaymentForm';
import { selectModal, selectOrder } from '@/store/selectors';
import { closeModal } from '@/store/slices/modal';
import { ScrollBar } from '@/styles/global';

const boxStyle = {
  position: 'absolute',
  height: '715px',
  width: '793px',
  backgroundColor: '#FAFAFA',
  borderRadius: '10px',
  overflow: 'auto',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  margin: 'auto',
  textAlign: 'center',
  py: 4,
  px: 8,
  ...ScrollBar,
};
const SubmitPayment = () => {
  const { submitPayment } = useSelector(selectModal);
  const { current_invoice: invoice, customer } = useSelector(selectOrder);
  const dispatch = useDispatch();

  const handleModalClose = () => {
    dispatch(closeModal({ type: 'submitPayment' }));
  };

  return (
    <div>
      <Modal
        open={submitPayment}
        onClose={handleModalClose}
        aria-labelledby="logout-modal-title"
        aria-describedby="logout-modal-description"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Slide direction="up" in={submitPayment} mountOnEnter unmountOnExit>
          <Box sx={boxStyle}>
            <Box sx={{ textAlign: 'left', marginBottom: 6 }}>
              <IconButton
                onClick={handleModalClose}
                sx={{
                  width: '92px',
                  height: '40px',
                  borderRadius: '90px',
                  p: '12px 16px',
                  position: 'absolute',
                  left: 0,
                  top: '10px',
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    marginLeft: 1,
                    fontFamily: 'Montserrat',
                    color: (theme) => theme.palette.primary.main,
                  }}
                >
                  Close
                </Typography>
              </IconButton>
            </Box>
            <Typography
              variant="h4"
              sx={{
                lineHeight: '15px',
                fontWeight: 600,
                textAlign: 'center',
                fontSize: '20px',
                fontFamily: 'Montserrat',
                textTransform: 'uppercase',
                color: (theme) => theme.palette.primary.main,
              }}
            >
              Thank you for your order
            </Typography>
            <Typography
              sx={{
                mt: 1,
                fontFamily: 'Montserrat',
                fontSize: '13px',
                '& span': {
                  fontWeight: 600,
                  mr: 1,
                },
              }}
            >
              <span>{customer}</span>
              {invoice}
            </Typography>
            <SubmitPaymentForm />
          </Box>
        </Slide>
      </Modal>
    </div>
  );
};

export default SubmitPayment;
